import Vue from 'vue';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';
import dropsLoader from '@/mixins/components/drops-loader';

export default Vue.component('edit-user-modal', {
  template: require('./template.html'),
  name: 'edit-user-modal',
  mixins: [guid],
  components: {
    dropsLoader,
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'websites',
      'subUsers',
    ]),
  },
  props: [
    'modal',
    'toggle-modal',
    'current-sub-user',
  ],
  data() {
    return {
      loading: false,
      selectedType: 'editor',
    };
  },
  methods: {
    async removeSubUser() {
      this.loading = true;
      const notif = {
        id: this.guid(),
        type: 'success',
        message: 'Successfully removed sub-user!',
      };
      try {
        const { _id, sub } = this.currentSubUser;
        await this.$lightning([{
          name: 'removeFromWorkspace',
          payload: { subUser: { _id, sub } },
        }]);
        const { subUsers } = this.currentUser;
        const index = subUsers.findIndex(u => u._id === _id);
        if (index > -1) {
          this.$store.dispatch('runStateFn', {
            fn() {
              subUsers.splice(index, 1);
            },
          });
        }
        const { websites } = this;
        websites.forEach((site) => {
          if (site.collaborators && site.collaborators[_id]) {
            this.$store.dispatch('runStateFn', {
              fn() {
                delete site.collaborators[_id];
              },
            });
          }
        });
        const globalSubs = this.subUsers;
        const idx = globalSubs.findIndex(u => u._id === _id);
        if (idx > -1) {
          this.$store.dispatch('runStateFn', {
            fn() {
              globalSubs.splice(idx, 1);
            },
          });
        }
        this.closeModal('editUser');
      } catch (e) {
        this.$log.error(e);
        notif.type = 'error';
        notif.message = e.message || e;
        await this._reportError({
          error: e,
          fn: 'removeSubUser',
        });
      } finally {
        this.loading = false;
        this.$store.dispatch('addNotification', notif);
        this._trackEvent({
          type: 'delete_subuser',
          meta: {
            full_name: this.currentSubUser.fullName,
            email: this.currentSubUser.email,
          },
        });
      }
    },
    closeModal(type) {
      this.$emit('toggle-modal', type, 'child');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/sub-users/edit-user-modal/index.js